import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CsrfService {
  private http = inject(HttpClient);

  private csrfToken: string | null = null;

  getCsrfToken(): string | null {
    if (!this.csrfToken) {
      this.csrfToken = this.readCsrfCookie();
    }
    return this.csrfToken;
  }

  refreshCsrfToken(): void {
    this.csrfToken = this.readCsrfCookie();
  }

  private readCsrfCookie(): string | null {
    const name = 'XSRF-TOKEN=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');

    for (const cookie of cookies) {
      const trimmed = cookie.trim();
      if (trimmed.indexOf(name) === 0) {
        return trimmed.substring(name.length);
      }
    }
    return null;
  }
}
